export const ADS_CONFIG = {
  conversionId: 'AW-11501218637',
  conversionLabels: {
    contactForm: 'pdtKCMPeu_gZEM3Wmswq',
    trainingRequest: 'pdtKCMPeu_gZEM3Wmswq'
  }
};

export const trackConversion = (type: keyof typeof ADS_CONFIG.conversionLabels) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'conversion', {
      'send_to': `${ADS_CONFIG.conversionId}/${ADS_CONFIG.conversionLabels[type]}`,
      'value': 1.0,
      'currency': 'EUR'
    });
  }
};